module.exports = __webpack_public_path__ + "img/file-pdf-solid.9ac6205a.svg";